import * as t from "./actionTypes";
import { entityIconsService } from "client-app-core";
import keyBy from "lodash/keyBy";

const entityIconTypes = ["icons", "shapes", "colors"];
/*
 * SET entityIcons by type
 */
const setEntityIconTypes = (type, data) => {
	const formattedData = keyBy(data, "id");
	switch (type) {
		case "icons":
			return {
				type: t.GET_FRAME_ICONS,
				payload: { type: "frame_icons", icons: formattedData }
			};

		case "shapes":
			return {
				type: t.GET_FRAME_SHAPES,
				payload: { type: "frame_shapes", shapes: formattedData }
			};
		case "colors":
			return {
				type: t.GET_FRAME_COLORS,
				payload: { type: "frame_colors", colors: formattedData }
			};
		default:
			return;
	}
};

/*
 * GET entityIcons by type
 */
export const getEntityIconsByType = () => {
	return (dispatch) => {
		entityIconTypes.forEach((type) => {
			entityIconsService.getAllEntityIconsByType(type, (err, response) => {
				if (err) {
					console.log(err);
				} else {
					dispatch(setEntityIconTypes(type, response));
				}
			});
		});
	};
};
